export default __webpack_public_path__ + "static/media/loja3.516f5ae9.jpeg";